import { Icon, type IconProps } from "@chakra-ui/icon";

const BrandCirclePause = (props: IconProps) => {
	return (
		<Icon
			viewBox="0 0 11 11"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.5 0C2.46243 0 0 2.46243 0 5.5C0 8.53757 2.46243 11 5.5 11C8.53757 11 11 8.53757 11 5.5C11 2.46243 8.53757 0 5.5 0ZM4.75 4C4.75 3.72386 4.52614 3.5 4.25 3.5C3.97386 3.5 3.75 3.72386 3.75 4V7C3.75 7.27614 3.97386 7.5 4.25 7.5C4.52614 7.5 4.75 7.27614 4.75 7V4ZM7.25 4C7.25 3.72386 7.02614 3.5 6.75 3.5C6.47386 3.5 6.25 3.72386 6.25 4V7C6.25 7.27614 6.47386 7.5 6.75 7.5C7.02614 7.5 7.25 7.27614 7.25 7V4Z"
				fill="currentColor"
			/>
		</Icon>
	);
};

export default BrandCirclePause;
